import nl from "./nl.json";
import en from "./en.json";

const messages = {
  nl: nl,
  en: en,
};

export default messages;
